import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CumulateListsLengthsPipe } from './cumulate-lists-lengths.pipe';



@NgModule({
  declarations: [CumulateListsLengthsPipe],
  exports: [CumulateListsLengthsPipe]
})
export class CumulateListsLengthsModule { }
